export default __webpack_public_path__ + "static/media/bank5.c07247c5.png";